const FormRow = ({ children, extraClasses = '' }) => (
    <div className={`form-row ${extraClasses}`}>{children}</div>
);

export default FormRow;
